import { render, staticRenderFns } from "./widgetForm.vue?vue&type=template&id=7b3e4072&scoped=true&"
import script from "./widgetForm.vue?vue&type=script&lang=js&"
export * from "./widgetForm.vue?vue&type=script&lang=js&"
import style0 from "./widgetForm.vue?vue&type=style&index=0&id=7b3e4072&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3e4072",
  null
  
)

export default component.exports